import { createId as cuid } from '@paralleldrive/cuid2';

export const createId = (): string => cuid().slice(0, 20);
